import { OfferFormOptionsResponseDto, OfferResponseDto } from '../types/response';

/** Same rule as the backend: the contract's current start date – also when it lies in the past – plus every upcoming 1st/15th. */
export const toCorrectionStartDateOptions = (startDateOptions: string[], current: string | null): string[] =>
  current && !startDateOptions.includes(current) ? [...startDateOptions, current].sort() : startDateOptions;

/**
 * The form options plus what the contract already contains: its product (with the contract's price for its term) and add-ons
 * stay selectable even if archived since – the backend keeps them as they are.
 */
export const toCorrectionFormOptions = (offer: OfferResponseDto, options: OfferFormOptionsResponseDto): OfferFormOptionsResponseDto => {
  const { productId, term, title, description, capacity, monthlyPriceCents, additionalConditions } = offer.product;
  const contractPrice = { term, monthlyPriceCents, additionalConditions };
  const activeProduct = options.products.find(({ _id }) => _id === productId);

  const products = activeProduct
    ? options.products.map((product) =>
        product._id === productId && !product.prices.some((price) => price.term === term)
          ? { ...product, prices: [...product.prices, contractPrice] }
          : product
      )
    : [...options.products, { _id: productId, title, description, capacity, prices: [contractPrice] }];

  const archivedAddOns = offer.addOns
    .filter(({ addOnId }) => !options.addOns.some(({ _id }) => _id === addOnId))
    .map(({ addOnId, title: addOnTitle, description: addOnDescription }) => ({ _id: addOnId, title: addOnTitle, description: addOnDescription }));

  return { products, addOns: [...options.addOns, ...archivedAddOns] };
};
